import Tree from './tree.vue';
export default Tree;


// WEBPACK FOOTER //
// ./src/components/tree/index.js